import React from 'react';
import './multiLevelTable.css';
import MultiQtyCell from '../dms_common/MultiQtyCell';

interface ColumnMetaData {
    headerName: string;
    width: string;
    mappedValue?: string;
    displayType?: string;
    renderCell?: (rowData:any)=>JSX.Element;
    redirectFunction?: (rowData:any)=>void;
}

interface MultiLevelSubTableProps {
    rowData: any[];
    columnsMetaData: ColumnMetaData[];
    otherUnitName: string|undefined
}

const MultiLevelSubTable = ({rowData, columnsMetaData, otherUnitName}: MultiLevelSubTableProps) => {

    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    
    const renderCellContent = (col: ColumnMetaData, row: any) => {
        if (col.renderCell) {
            return col.renderCell(row);
        }
        
        if (!col.mappedValue) {
            return '';
        }
        
        const value = row[col.mappedValue];
        
        switch (col.displayType) {
            case 'amount':
                return typeof value === 'number' ? `${ConfigDictionary.currency} ${value.toFixed(2)}` : value;
            case 'quantity':
                return renderMultiQtyCell(col, row);
            default:
                return <div className="cell-content">{value}</div>;
        }
    };
    
    const renderMultiQtyCell = (col:ColumnMetaData, row:any)=>{
        const parts = col.mappedValue?.split(',');
        if(!parts) return '';
        return <MultiQtyCell
            csQty={row[parts[0]]}
            pcQty={row[parts[1]]}
            otherQty={row[parts[2]]}
            hasEditButton={false}
            otherUnitName={otherUnitName}
        />;
    }
    
    return (
        <div className="multi-level-sub-table">
            <div className="table-header">
                <div className="table-row">
                    {columnsMetaData.map((col, idx) => {
                        return (
                        <div key={idx} className="table-cell header-cell" style={{ width: col.width}}>
                            {col.headerName}
                        </div>
                    )})}
                </div>
            </div>
            <div className="table-body">
                {rowData.map((row, rowIdx) => (
                    <div key={rowIdx} className="table-row">
                        {columnsMetaData.map((col, colIdx) => (
                            <div key={colIdx} className="table-cell" style={{ width: col.width }}>
                                {renderCellContent(col, row)}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MultiLevelSubTable; 